
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporate-social-responsibility",
      function () {
        return require("private-next-pages/corporate-social-responsibility.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporate-social-responsibility"])
      });
    }
  